import { MenuActions } from '../configuration/menu-actions';

export class CtxMessage {
  azione: MenuActions;
  idTipoPratica: any;
  idTipoFascicolo: any;
  idEntita: string;
  idActiveButton: string;
  constructor(azione: MenuActions, idTipoPratica: any, idTipoFascicolo: any, idEntita: string, idActiveButton: string) {
    this.azione = azione;
    this.idTipoPratica = idTipoPratica;
    this.idTipoFascicolo = idTipoFascicolo;
    this.idEntita = idEntita;
    this.idActiveButton = idActiveButton;
  }
}
